import { formatDuration } from "util/util";

function renderDate(timestamp: number, format: Intl.DateTimeFormatOptions) {
  const date = new Date(timestamp);
  // This is kind of a hack. Our UI is in English so we want dates in English,
  // but it's nice to respect English subvariants/regions. I can't figure out
  // a way to make Intl automatically detect this, so we're doing it manually.
  // This probably doesn't actually matter much in practice.
  const locale =
    navigator.languages?.find((lang) => lang.startsWith("en")) ?? "en";
  const server = date.toLocaleString(locale, {
    ...format,
    timeZoneName: "short",
    timeZone: "America/New_York",
  });
  const client = date.toLocaleString(locale, format);
  return (
    <time dateTime={date.toISOString()} title={`Server time: ${server}`}>
      {client.replace(/([a-z])\s([0-9])/gi, "$1\u00a0$2")}
    </time>
  );
}

export function LongDate({ timestamp }: { timestamp: number }) {
  return renderDate(timestamp, {
    hourCycle: "h12",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function ShortDate({ timestamp }: { timestamp: number }) {
  return renderDate(timestamp, {
    hourCycle: "h23",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function Duration(
  props: { from: number; to: number } | { diff: number }
) {
  const diff = "diff" in props ? props.diff : props.to - props.from;
  return <time dateTime={`PT${diff / 1000}S`}>{formatDuration(diff)}</time>;
}
